module.exports = __webpack_public_path__ + "img/brand-favicon.41157113.png";